import { Injectable } from '@angular/core';
import { PortalService } from './portal.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    private permissionsSet = new Set<string>();

    // Ações padrão do sistema
    private readonly DEFAULT_ACTIONS = [
        'consultar',
        'criar',
        'editar',
        'excluir',
    ];

    constructor(private portalService: PortalService) {}

    private formatarPermissao(valor: string): string {
        return valor
            .split(':')
            .map(segmento => segmento.trim().toLowerCase())
            .join(':');
    }

    setUserPermissions(permissoes: string[]): void {
        this.permissionsSet = new Set();

        const expandedPermissions = this.expandPermissions(
            permissoes.map(p => this.formatarPermissao(p))
        );
        this.permissionsSet = new Set(expandedPermissions);
    }

    private expandPermissions(permissions: string[]): string[] {
        const expandedPermissions: string[] = [];

        for (const permission of permissions) {
            const parts = permission.split(':');

            if (parts.length < 4) {
                console.warn(`Permissão mal formada encontrada: ${permission}`);
                continue;
            }

            const [portal, dominio, recurso, ...acoes] = parts;
            const prefixo = `${portal}:${dominio}:${recurso}:`;

            if (acoes.length === 0) {
                continue;
            }

            if (acoes.length === 1) {
                const acao = acoes[0];
                if (acao === 'todas') {
                    for (const defaultAction of this.DEFAULT_ACTIONS) {
                        expandedPermissions.push(prefixo + defaultAction);
                    }
                } else {
                    expandedPermissions.push(prefixo + acao);
                }
                continue;
            }

            for (const acao of acoes) {
                expandedPermissions.push(prefixo + acao);
            }
        }

        return expandedPermissions;
    }

    hasAnyPermission(permissions: string[], dominio?: string): boolean {
        for (const permissao of permissions) {
            if (this.hasPermission(permissao, dominio)) return true;
        }
        return false;
    }

    hasPermission(permission: string, dominio?: string): boolean {
        const portalAtual = this.portalService.portal;
        const acao = permission.split(':')[3];
        if (!portalAtual) return false;
        if (portalAtual === 'coordenador' || portalAtual === 'gestor')
            if (acao === 'criar' || acao === 'editar') return false;
            else return true;

        const p = this.formatarPermissao(permission);

        if (!p.startsWith(portalAtual + ':')) return false;

        if (dominio) {
            const partes = p.split(':');
            const dominioPerm = partes[1];
            if (dominioPerm !== this.formatarPermissao(dominio).split(':')[0]) {
                return false;
            }
        }
        return this.permissionsSet.has(p);
    }

    clearPermissions(): void {
        this.permissionsSet.clear();
    }
}
